import type { ChipProps } from '@mui/material';
import type { TFunction } from 'i18next';

/**
 * 在线状态阈值常量（毫秒）
 */
const ONLINE_THRESHOLD_MS = 5 * 60 * 1000; // 5 分钟
const RECENTLY_ACTIVE_THRESHOLD_MS = 30 * 60 * 1000; // 30 分钟

/**
 * 根据最后心跳时间判断设备在线状态
 * @param lastHeartbeat 最后心跳时间字符串
 * @param t i18next 翻译函数
 * @returns 翻译后的状态字符串
 */
export function getOnlineStatus(
  lastHeartbeat: string | null,
  t: TFunction
): string {
  if (!lastHeartbeat) return t('devices.unknown');

  try {
    const date = new Date(lastHeartbeat);
    if (Number.isNaN(date.getTime())) return t('devices.unknown');

    const diff = Date.now() - date.getTime();

    if (diff < ONLINE_THRESHOLD_MS) return t('devices.online');
    if (diff < RECENTLY_ACTIVE_THRESHOLD_MS) return t('devices.recentlyActive');
    return t('devices.offline');
  } catch {
    return t('devices.unknown');
  }
}

/**
 * 根据在线状态获取对应的 Chip 颜色
 * @param status 在线状态字符串（已翻译）
 * @returns Chip 颜色值
 */
export function getOnlineStatusColor(status: string): ChipProps['color'] {
  // 注意：这里需要根据翻译后的状态来判断
  // 由于 status 已经是翻译后的字符串，我们使用状态的关键词来判断
  if (status === 'online' || status.includes('在线') || status.includes('Online')) {
    return 'success';
  }
  if (status === 'recentlyActive' || status.includes('近期') || status.includes('Recently')) {
    return 'warning';
  }
  return 'default';
}
